export default __webpack_public_path__ + "static/media/banana.68479bbc.obj";